import React from 'react';

const News = () => {
    return (
        <div>
            <h2>This is News</h2>
        </div>
    );
};

export default News;